import { DataBean } from "../DataBean";

export class CostStudy extends DataBean {


    public async getCostStudyCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getCostStudyCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

   

 
}